// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/_vue-style-loader@1.0.0@vue-style-loader!./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-76763617&scoped=true!./~/_less-loader@2.2.3@less-loader?sourceMap!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-tags.vue
// module id = 1177
// module chunks = 129